import { render, staticRenderFns } from "./SurveyBlock.vue?vue&type=template&id=6a4d28c6&scoped=true"
import script from "./SurveyBlock.vue?vue&type=script&lang=js"
export * from "./SurveyBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4d28c6",
  null
  
)

export default component.exports